import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import useModalHistory from '../../../hooks/useModalHistory';
import '../../../styles/phrase-modal.css'; // Import CSS file

const ViewPhraseModal = ({ show, onHide, phraseData }) => {
    useModalHistory(show, onHide, 'phrase-view-modal');
  
  if (!phraseData) return null;
  
  const phrases = phraseData.phrases || [];
  const totalPhrases = phrases.length;
  const halfCount = totalPhrases / 2;
  
  // Generate input fields with proper numbering
  const renderPhraseInputs = () => {
    const leftColumnInputs = [];
    const rightColumnInputs = [];
    
    // Generate inputs for both columns
    for (let i = 0; i < totalPhrases; i++) {
      const input = (
        <div key={i} className="phrase-input-container">
          <span className="phrase-number">{i + 1}</span>
          <Form.Control
            id={`viewPhrase-${i + 1}`}
            type="text"
            value={phrases[i] || ''}
            readOnly
            className="phrase-input"
          />
        </div>
      );
      
      // Add to appropriate column
      if (i < halfCount) {
        leftColumnInputs.push(input);
      } else {
        rightColumnInputs.push(input);
      }
    }
    
    return (
      <div className="phrase-grid-container">
        <div className="phrase-column">
          {leftColumnInputs}
        </div>
        <div className="phrase-column">
          {rightColumnInputs}
        </div>
      </div>
    );
  };
  
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton className="custom-header">
        <Modal.Title>View Secure Phrase</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-4">
            <Form.Label>Phrase Alias:</Form.Label>
            <Form.Control 
              type="text" 
              id="viewPhraseAlias"
              value={phraseData.alias || ''} 
              readOnly 
            />
          </Form.Group>
          
          {/* Render phrase inputs with CSS classes */}
          {renderPhraseInputs()}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={onHide} 
          className="modal-close-btn"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewPhraseModal;